/* Pouchman product page: vector mascot, can striker, tin gallery. Runs after pouchman.js. */
/* Vector Pouchman. The head is the theme's own CSS 3D tin (pouchman-head.css),
   the body is SVG lines traced from the mascot art at 430x640. Every joint
   is a group with its own rotation, so a pose is a set of angles and any
   pose can tween to any other. Angles: degrees from straight down, positive
   toward the figure's right (screen +x). */
window.PMX = window.PMX || {};
(function () {
  const NS = 'http://www.w3.org/2000/svg';
  const SEG = { neck: 26, torso: 137, upper: 90, fore: 91, thigh: 90, shin: 124 };
  const SHOULDER = [200, 248], HIP = [200, 385], HEAD = [197, 118], HEAD_D = 210;

  PMX.poses = {
    /* right arm = screen right; l/r upper = absolute; fore = relative to upper */
    offer: { ru: 43, rf: 63, lu: -42, lf: 76, lt: -22, ls: 12, rt: 21, rs: -10, rhand: 'open', lhand: 'hidden', lean: 0 },
    wink:  { ru: 60, rf: 52, lu: -35, lf: 25, lt: -19, ls: 10, rt: 18, rs: -8, rhand: 'open', lhand: 'open', lean: 0 },
    point: { ru: 60, rf: 97, lu: -35, lf: 25, lt: -19, ls: 10, rt: 18, rs: -8, rhand: 'open', lhand: 'open', lean: 0 },
    idle:  { ru: 22, rf: 8, lu: -22, lf: -8, lt: -12, ls: 4, rt: 12, rs: -4, rhand: 'open', lhand: 'open', lean: 0 },
    walkA: { ru: -38, rf: -14, lu: 42, lf: 18, lt: 36, ls: -8, rt: -30, rs: 44, rhand: 'open', lhand: 'open', lean: 6 },
    walkB: { ru: 42, rf: 18, lu: -38, lf: -14, lt: -30, ls: 44, rt: 36, rs: -8, rhand: 'open', lhand: 'open', lean: 6 },
    alert: { ru: 74, rf: 62, lu: -22, lf: -6, lt: -18, ls: 8, rt: 18, rs: -8, rhand: 'open', lhand: 'open', lean: 0 },
    tense: { ru: 52, rf: 118, lu: -52, lf: -118, lt: -26, ls: 12, rt: 26, rs: -12, rhand: 'open', lhand: 'open', lean: 0 },
    brace: { ru: 148, rf: 12, lu: -148, lf: -12, lt: -32, ls: 16, rt: 32, rs: -16, rhand: 'open', lhand: 'open', lean: 0 },
    jump:  { ru: 165, rf: 0, lu: -165, lf: 0, lt: -38, ls: 58, rt: 38, rs: -58, rhand: 'open', lhand: 'open', lean: 0 },
    wave:  { ru: 138, rf: 18, lu: -30, lf: 20, lt: -19, ls: 10, rt: 18, rs: -8, rhand: 'open', lhand: 'open', lean: 0 },
  };

  function el(tag, attrs, parent) {
    const n = document.createElementNS(NS, tag);
    for (const k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function limb(parent, x, y, len, cls) {
    const g = el('g', { class: cls, transform: `translate(${x} ${y})` }, parent);
    g.dataset.x = x; g.dataset.y = y;
    el('line', { x1: 0, y1: 0, x2: 0, y2: len, class: 'pmv__ln' }, g);
    const j = el('g', { transform: `translate(0 ${len})` }, g);
    return { g, j };
  }

  PMX.rig = function (host, opts) {
    opts = Object.assign({ pose: 'offer', face: '' }, opts || {});
    host.classList.add('pmv');
    host.innerHTML =
      `<div class="pm-head${opts.face ? ' ' + opts.face : ''}" aria-hidden="true"><div class="pm-cyl"></div>` +
      `<i class="pm-cap pm-far"></i><i class="pm-cap pm-near"></i>` +
      `<div class="pm-face"><i class="pm-eye pm-l"></i><i class="pm-eye pm-r"></i><b class="pm-mouth"></b><i class="pm-brow"></i></div></div>`;
    const head = host.firstChild;
    let cylHtml = '';
    for (let i = 0; i < 36; i++) for (const b of ['pm-lid', 'pm-band', 'pm-base']) cylHtml += `<b class="${b}" style="--i:${i}"></b>`;
    head.querySelector('.pm-cyl').innerHTML = cylHtml;

    const svg = el('svg', { viewBox: '0 0 430 640', class: 'pmv__body', 'aria-hidden': 'true' }, host);
    const body = el('g', { class: 'pmv__lean' }, svg);
    el('line', { x1: SHOULDER[0], y1: SHOULDER[1] - SEG.neck, x2: SHOULDER[0], y2: SHOULDER[1], class: 'pmv__ln' }, body);
    el('line', { x1: SHOULDER[0], y1: SHOULDER[1], x2: HIP[0], y2: HIP[1], class: 'pmv__ln' }, body);
    const parts = {};
    for (const side of ['l', 'r']) {
      const u = limb(body, SHOULDER[0], SHOULDER[1], SEG.upper, 'pmv__u-' + side);
      const f = limb(u.j, 0, 0, SEG.fore, 'pmv__f-' + side);
      const hand = el('g', { class: 'pmv__hand' }, f.j);
      el('circle', { cx: 0, cy: 6, r: 19, class: 'pmv__fill pmv__palm' }, hand);
      /* hands are only ever the ball. No fingers, no thumbs: owner's call
         after a stub read as a middle finger. */
      const t = limb(body, HIP[0], HIP[1], SEG.thigh, 'pmv__t-' + side);
      const s = limb(t.j, 0, 0, SEG.shin, 'pmv__s-' + side);
      el('ellipse', { cx: side === 'l' ? -14 : 14, cy: 6, rx: 36, ry: 12, class: 'pmv__fill' }, s.j);
      parts[side] = { u, f, hand, t, s };
    }

    const state = { pose: null, head: head, host: host };
    function setPose(p, ms) {
      if (typeof p === 'string') p = PMX.poses[p];
      const dur = ms == null ? 420 : ms;
      const tf = `transform ${dur}ms cubic-bezier(.34,1.2,.64,1)`;
      const set = (part, a) => { part.g.style.transition = tf; part.g.style.transform = `translate(${part.g.dataset.x}px,${part.g.dataset.y}px) rotate(${-a}deg)`; part.g.removeAttribute('transform'); };
      set(parts.r.u, p.ru); set(parts.r.f, p.rf); set(parts.l.u, p.lu); set(parts.l.f, p.lf);
      set(parts.l.t, p.lt); set(parts.l.s, p.ls); set(parts.r.t, p.rt); set(parts.r.s, p.rs);
      parts.r.hand.dataset.kind = p.rhand; parts.l.hand.dataset.kind = p.lhand;
      /* hands stay upright whatever the arm does */
      parts.r.hand.style.transform = `rotate(${p.ru + p.rf}deg)`; parts.l.hand.style.transform = `rotate(${p.lu + p.lf}deg)`;
      parts.r.hand.style.transition = parts.l.hand.style.transition = tf;
      body.style.transition = tf; body.style.transformOrigin = `${HIP[0]}px ${HIP[1]}px`; body.style.transform = `rotate(${-p.lean}deg)`;
      state.pose = p;
    }
    /* head follows the rig size: measured, not guessed */
    function size() {
      const w = host.clientWidth || 430;
      const d = w * HEAD_D / 430;
      head.style.setProperty('--d', d.toFixed(1) + 'px');
      head.style.left = (w * HEAD[0] / 430 - d / 2).toFixed(1) + 'px';
      head.style.top = (host.clientHeight * HEAD[1] / 640 - d / 2).toFixed(1) + 'px';
    }
    new ResizeObserver(size).observe(host); size();
    setPose(opts.pose, 0);

    let walking = 0;
    return {
      pose: setPose, head, host,
      walk(on, period) {
        clearInterval(walking); walking = 0;
        if (!on) return;
        let a = false; setPose('walkA', period / 2);
        walking = setInterval(() => { a = !a; setPose(a ? 'walkB' : 'walkA', period / 2); }, period / 2);
      },
      blink() { head.classList.add('is-blink'); setTimeout(() => head.classList.remove('is-blink'), 140); },
      look(yaw, pitch) { head.style.setProperty('--yaw', yaw + 'deg'); head.style.setProperty('--pitch', (pitch || 0) + 'deg'); },
      face(kind) { const f = head.querySelector('.pm-face'); f.classList.toggle('pm-smirk', kind === 'smirk' || kind === 'both'); f.classList.toggle('pm-raised', kind === 'raised' || kind === 'both'); },
    };
  };
})();

/* Can tower: the quantity picker as a high striker, in the shop's own
   materials. The stack is real side-view tins painted with the theme's tin
   shader (same lip, same wall, same key light as the 3D tin), the side lights
   sit every five cans, the red dome on top lights at the full stack, and
   Pouchman winds up as the stack climbs. Slider, drag, and the -/+ buttons
   all drive one setter. */
window.PMX = window.PMX || {};
PMX.tower = function (host, p, opts) {
  const o = Object.assign({ max: 20, unit: 900, tiers: [[1, 0], [5, 5], [7, 7], [10, 10], [15, 15], [20, 20]], freeShipAt: 3, lightsEvery: 5, body: null, onChange: null }, opts || {});
  const pct = n => o.tiers.reduce((a, t) => n >= t[0] ? t[1] : a, 0);
  const inr = v => 'Rs. ' + Math.round(v).toLocaleString('en-IN');
  const lights = []; for (let i = o.lightsEvery; i <= o.max; i += o.lightsEvery) lights.push(i);
  host.classList.add('tw');
  const zone = i => i < 7 ? 'g' : i < 14 ? 'y' : 'r';
  const prebuilt = !!host.querySelector('.tw__stage');
  const bulbs = side => Array.from({ length: o.max }, (_, i) => `<i class="tw__bulb tw__bulb--${zone(i)}" style="--i:${i}" data-at="${i + 1}">${side === 'l' && (i + 1) % o.lightsEvery === 0 ? `<b>${i + 1}</b>` : ''}</i>`).join('');
  if (!prebuilt) host.innerHTML = `
    <div class="tw__stage">
      <div class="tw__machine">
        <div class="tw__cap"><div class="tw__dome" aria-hidden="true"><i></i></div></div>
        <div class="tw__board">
          <div class="tw__col tw__col--l">${bulbs('l')}</div>
          <div class="tw__chan">
            <div class="tw__cans">${Array.from({ length: o.max }, (_, i) => `<i style="--i:${i}"></i>`).join('')}</div>
            <input class="tw__range" type="range" min="1" max="${o.max}" value="1" aria-label="How many cans">
          </div>
          <div class="tw__col tw__col--r">${bulbs('r')}</div>
        </div>
        <div class="tw__base"></div>
      </div>
      <div class="tw__marks">${o.tiers.filter(t => t[1] > 0 && t[0] <= o.max).map(t => `<span style="--row:${t[0]}" data-at="${t[0]}"><b>${t[1]}%</b><em>off</em></span>`).join('')}</div>
      <div class="tw__man"><div class="tw__rig"></div><div class="tw__burst" aria-hidden="true"></div></div>
    </div>
    <div class="tw__ctl">
      <button type="button" class="tw__btn" data-d="-1" aria-label="One can fewer">&minus;</button>
      <div class="tw__count"><b data-n>1</b><span>can</span></div>
      <button type="button" class="tw__btn" data-d="1" aria-label="One can more">+</button>
      <div class="tw__read"><b data-total></b><span data-line></span></div>
      ${(() => { const nx = o.tiers.filter(t => t[0] > o.max)[0]; return nx ? `<p class="tw__next">Beyond the tower: ${nx[1]}% off from ${nx[0]} cans, applied at checkout.</p>` : ''; })()}
    </div>`;
  const cans = host.querySelectorAll('.tw__cans i'), range = host.querySelector('.tw__range');
  const marks = host.querySelectorAll('.tw__marks span'), lamps = host.querySelectorAll('.tw__bulb');
  const rigHost = host.querySelector('.tw__rig'), man = host.querySelector('.tw__man'), dome = host.querySelector('.tw__dome');
  /* paint the stacked tins with the theme's shader: a wall seen side-on runs
     from bearing -90 to +90 across its width */
  const rig = PMX.rig(rigHost, { pose: 'idle' });
  rigHost.insertAdjacentHTML('beforeend', '<svg class="tw__sweat" viewBox="0 0 60 60" aria-hidden="true"><path d="M9 4c3 6 6 9 6 13a6 6 0 0 1-12 0c0-4 3-7 6-13z"/><path d="M51 9c3 6 6 9 6 13a6 6 0 0 1-12 0c0-4 3-7 6-13z"/></svg>');
  let n = 1, lastStage = -1;
  function set(v, src) {
    n = Math.max(1, Math.min(o.max, Math.round(v)));
    const k = (n - 1) / (o.max - 1), d = pct(n), total = n * o.unit * (1 - d / 100), save = n * o.unit - total;
    host.style.setProperty('--k', k.toFixed(3));
    cans.forEach((c, i) => c.classList.toggle('on', i < n));
    marks.forEach(m => m.classList.toggle('on', n >= +m.dataset.at));
    lamps.forEach(b => b.classList.toggle('on', n >= +b.dataset.at));
    dome.classList.toggle('on', n >= o.max);
    if (src !== 'range') range.value = n;
    host.querySelector('[data-n]').textContent = n; host.querySelector('.tw__count span').textContent = n === 1 ? 'can' : 'cans';
    if (!o.onChange) { host.querySelector('[data-total]').textContent = inr(total); host.querySelector('[data-line]').textContent = d ? `${d}% off, you save ${inr(save)}` : ''; }
    const stage = n >= o.max ? 4 : k > 0.66 ? 3 : k > 0.4 ? 2 : k > 0.18 ? 1 : 0;
    var shake = stage === 4 ? 0 : Math.max(0, k - 0.18) * 6, sweat = Math.max(0, (k - 0.45) / 0.55);
    man.style.setProperty('--shake', shake.toFixed(2)); man.style.setProperty('--sweat', sweat.toFixed(2));
    man.classList.toggle('is-shaking', shake > 0.05); man.classList.toggle('is-sweating', sweat > 0.02);
    man.classList.toggle('is-ding', stage === 4);
    if (stage !== lastStage) {
      lastStage = stage;
      rig.pose(['idle', 'alert', 'tense', 'brace', 'jump'][stage], 380);
      rig.face(['neutral', 'raised', 'raised', 'both', 'smirk'][stage]);
      rig.look([-23.7, -16, -8, 0, -6][stage], [0, 4, 8, 12, -6][stage]);
    }
    if (o.onChange) o.onChange({ n, pct: d, total, save });
  }
  range.addEventListener('input', () => set(+range.value, 'range'));
  host.querySelectorAll('.tw__btn').forEach(b => b.addEventListener('click', () => set(n + +b.dataset.d)));
  const tower = host.querySelector('.tw__chan');
  const fromY = e => { const r = host.querySelector('.tw__cans').getBoundingClientRect(); return 1 + (1 - (e.clientY - r.top) / r.height) * (o.max - 1); };
  let drag = false;
  tower.addEventListener('pointerdown', e => { if (e.target === range) return; drag = true; tower.setPointerCapture(e.pointerId); set(fromY(e)); });
  tower.addEventListener('pointermove', e => { if (drag) set(fromY(e)); });
  tower.addEventListener('pointerup', () => { drag = false; }); tower.addEventListener('pointercancel', () => { drag = false; });
  set(1);
  return { set, get: () => n };
};


/* ---- product page wiring ---------------------------------------------------
   Runs after pouchman.js (both deferred, document order). The theme has
   already built and painted the tin from the featured image; this sizes it,
   walks the mascot in, floats the tin on hover, swaps the two slides, and
   mounts the striker over the theme's quantity input. */
(function () {
  var D = document, $ = function (s, r) { return (r || D).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var stage = $('.pdp__stage'); if (!stage) return;
  var money = function (cents) { return window.PM && PM.money ? PM.money(cents) : 'Rs. ' + (cents / 100).toFixed(2); };

  /* the same dominant-hue sampler the stage uses, for the striker's label band */
  function sample(img) {
    try {
      var c = D.createElement('canvas'), n = 24; c.width = c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, buckets = [];
      for (var bi = 0; bi < 12; bi++) buckets.push([0, 0, 0, 0]);
      for (var i = 0; i < n * n; i++) {
        if (Math.hypot((i % n) - (n - 1) / 2, ((i / n) | 0) - (n - 1) / 2) > n * 0.34) continue;
        var o = i * 4; if (d[o + 3] < 200) continue;
        var R = d[o], G = d[o + 1], B = d[o + 2], mx = Math.max(R, G, B), mn = Math.min(R, G, B);
        if (mx > 238 || mx < 26 || mx - mn < 18) continue;
        var h; if (mx === R) h = ((G - B) / (mx - mn) + 6) % 6; else if (mx === G) h = (B - R) / (mx - mn) + 2; else h = (R - G) / (mx - mn) + 4;
        var bk = buckets[Math.floor(h) * 2 + (h % 1 > 0.5 ? 1 : 0)]; bk[0] += R; bk[1] += G; bk[2] += B; bk[3]++;
      }
      var best = buckets[0]; buckets.forEach(function (bk) { if (bk[3] > best[3]) best = bk; });
      if (best[3] < 8) return null;
      return [best[0] / best[3], best[1] / best[3], best[2] / best[3]];
    } catch (e) { return null; }
  }
  var mix = function (rgb, k, to) { return 'rgb(' + rgb.map(function (v) { return Math.round(to * k + v * (1 - k)); }).join(',') + ')'; };

  /* ---- slides ---- */
  var slides = $$('.pg__slide', stage), thumbs = $$('.pg__thumb');
  function show(key) {
    slides.forEach(function (s) { s.classList.toggle('is-on', s.dataset.slide === key); });
    thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.dataset.slide === key)); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.slide); }); });

  /* ---- the tin: sized to the stage, floated on hover ---- */
  var tinWrap = $('.pg__tin', stage), tin = tinWrap && $('.bkw', tinWrap);
  function sizeTin() { if (!tin) return; var w = $('.pg__slides', stage).clientWidth; tin.style.setProperty('--d', Math.round(w * 0.6) + 'px'); }
  if (tin) { sizeTin(); if (window.ResizeObserver) new ResizeObserver(sizeTin).observe($('.pg__slides', stage)); }
  var amp = 0, target = 0, hot = false, arrived = false, wantHot = false, looping = false;
  function loop(t) {
    amp += (target - amp) * 0.06;
    if (target === 0 && amp < 0.002) { amp = 0; looping = false; if (tin) tin.style.translate = ''; return; }
    if (tin) tin.style.translate = '0 ' + (amp * 11 * Math.sin(t / 1000 * 1.4)).toFixed(2) + 'px';
    requestAnimationFrame(loop);
  }
  function setFloat(on) { target = on ? 1 : 0; if (on && !looping) { looping = true; requestAnimationFrame(loop); } }

  /* ---- the mascot: walks in, then points at the tin on hover ---- */
  var rigHost = $('.pg__rig', stage), rig = null;
  if (rigHost && window.PMX && PMX.rig && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
    rig = PMX.rig(rigHost, { pose: 'walkA' });
    rigHost.style.transform = 'translateX(-140%)';
    rig.walk(true, 600);
    requestAnimationFrame(function () { requestAnimationFrame(function () { rigHost.style.transform = 'translateX(0)'; }); });
    setTimeout(function () {
      rig.walk(false); rig.pose('wink', 420); rig.look(-12, 3);
      setTimeout(function () { if (!hot) rig.pose('idle', 500); }, 1300);
      setInterval(function () { rig.blink(); }, 3600);
      arrived = true; if (wantHot) hover(true);
    }, 1450);
  } else if (rigHost && window.PMX && PMX.rig) {
    rig = PMX.rig(rigHost, { pose: 'idle' }); arrived = true;
  }
  function aim() {
    if (!tin || !rigHost) return 40;
    var s = rigHost.getBoundingClientRect(), t = tin.getBoundingClientRect();
    var k = s.width / 430, sx = s.left + 200 * k, sy = s.top + 248 * k;
    return Math.atan2((t.left + t.width / 2) - sx, (t.top + t.height / 2) - sy) * 180 / Math.PI;
  }
  function hover(on) {
    wantHot = on; if (!arrived) return;
    hot = on; setFloat(on);
    if (!rig) return;
    if (on) { var a = aim(); rig.pose(Object.assign({}, PMX.poses.idle, { ru: a, rf: 0, lu: -18, lf: -6 }), 420); rig.look(-4, 8); }
    else { rig.pose('idle', 480); rig.look(-23.7, 0); }
  }
  stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover(true); });
  stage.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover(false); });
  if (tinWrap) tinWrap.addEventListener('click', function () { hover(!hot); });

  /* ---- the striker over the theme's quantity input ---- */
  var host = $('#pmTower'); if (!host || !window.PMX || !PMX.tower) return;
  var variants = []; try { variants = JSON.parse($('#pdpVariants').textContent) || []; } catch (e) {}
  function unit() { var id = $('#variantId') && $('#variantId').value; var v = variants.filter(function (x) { return String(x.id) === String(id); })[0]; return v ? v.price : (+host.dataset.unit || 0); }
  var ladder = (host.dataset.ladder || '').split(',').map(function (s) { var b = s.split('|'); return [parseInt(b[0], 10), parseFloat(b[1])]; }).filter(function (t) { return t[0] > 0 && t[1] >= 0; });
  ladder.unshift([1, 0]);
  var max = parseInt(host.dataset.max, 10) || 20, shipAt = parseInt(host.dataset.ship, 10) || 0;
  var current = { n: 1 };
  function apply() {
    var u = unit(), n = current.n, d = current.pct, total = u * n, after = total * (1 - d / 100);
    var q = $('#qtyInput'); if (q) q.value = n;
    var qo = $('#qtyOut'); if (qo) qo.textContent = n;
    var tot = $('#atcTotal'); if (tot) tot.textContent = money(after);
    var atc = $('#atc'); if (atc && !atc.disabled) atc.childNodes[0].nodeValue = 'Add ' + n + (n > 1 ? ' cans' : ' can') + ' · ';
    var mp = $('.mbar__info b'), mb = $('.mbar [data-variant-id]');
    if (mp) mp.textContent = money(after); if (mb) mb.dataset.qty = n;
    var read = $('[data-total]', host), line = $('[data-line]', host);
    if (read) read.textContent = money(after) + (d ? ' at checkout' : '');
    if (line) line.textContent = d ? d + '% off at checkout, you save ' + money(total - after) : (shipAt && n >= shipAt ? 'free delivery from here' : (shipAt ? shipAt + ' cans ships free' : ''));
  }
  var img = $('#pdpImg');
  var paintTint = function () { var rgb = sample(img); if (!rgb) return; host.style.setProperty('--tint-raw', mix(rgb, 0, 0)); host.style.setProperty('--tint-mid', mix(rgb, 0.25, 0)); };
  if (img) { if (img.complete && img.naturalWidth) paintTint(); else img.addEventListener('load', paintTint); }
  PMX.tower(host, {}, { max: max, unit: 1, tiers: ladder, freeShipAt: shipAt, onChange: function (s) { current = s; apply(); } });
  /* a variant change runs the theme's own paint(), which resets the input; reapply after it */
  D.addEventListener('click', function (e) { if (e.target.closest('[data-opt]')) setTimeout(apply, 0); });
})();
